import getEnv from '@settings/getEnv';
import { loggerFactory } from '@settings/services/logger';
import Cookies from 'cookies-ts';

import { CompanyProfileService } from './CompanyProfileService';
import { CompanyProfileServiceInterface } from './interface';

// Фабрика сервиса
export const companyProfileService: { (): CompanyProfileServiceInterface } = () => {
  const { REACT_APP_BITRIX_ENDPOINT, REACT_APP_AUTH_COOKIE } = getEnv();
  const cookies = new Cookies();

  const jwt = cookies.get(REACT_APP_AUTH_COOKIE);
  return new CompanyProfileService(loggerFactory(), REACT_APP_BITRIX_ENDPOINT, jwt ?? '');
};
